export default "__VITE_ASSET__9r8FDGCE__"